import { Theme, color, rem } from '@thiememeulenhoff/lit-sdk';
import { PaletteColor, ThemeColor, Tint } from '@thiememeulenhoff/tokens';
import { css, unsafeCSS } from 'lit';
import { tagName } from '../../helpers';
import { LabelVariant } from './label.types';

export const tag = tagName('label');
const theme = new Theme(tag);

const labelColors: Record<LabelVariant, ThemeColor | PaletteColor> = {
  neutral: 'grey',
  success: 'success',
  warning: 'warning',
  weergave: 'pink',
};

const labelTints: Record<LabelVariant, Tint> = {
  neutral: 600,
  success: 600,
  warning: 600,
  weergave: 800,
};

const labelVariant = (labelVariant: LabelVariant) => {
  const selector = unsafeCSS(`[variant=${labelVariant}]`);
  const labelColor = labelColors[labelVariant];
  const tint = labelTints[labelVariant];

  return css`
    :host(${selector}) {
      ${theme.props([
        ['background', `${labelColor}-background`, color(labelColor, 100)],
        ['color', `${labelColor}-color`, color(labelColor, tint)],
        [
          'border',
          `${labelColor}-border`,
          `${color(labelColor, 200)} solid ${rem(1)}`,
        ],
      ])};
    }
  `;
};

export const label = css`
  :host {
    align-items: center;
    block-size: ${rem(32)};
    border-radius: 50vh;
    display: inline-flex;
    gap: ${rem(8)};
    justify-content: center;
    padding: ${rem(8, 16)};
    text-align: center;
  }

  :host([size='small']) {
    font-size: ${rem(14)};
    padding: ${rem(4, 8)};
  }

  :host([size='medium']) {
    font-size: ${rem(16)};
    padding: ${rem(8, 16)};
  }

  ${labelVariant('neutral')}
  ${labelVariant('success')}
  ${labelVariant('warning')}
  ${labelVariant('weergave')}
`;
